import React, { useCallback } from 'react'
import { useDispatch } from 'react-redux';
import { removeUserDataDir, sendUserToFarmRewards, unsubscribePassUser } from '../../../Reducers/accounts';
import { Button, Tooltip, message } from 'antd';
import b_ from 'b_';

const SendToFarmRewardsButton = ({ record, afterUpdate, title, icon }) => {
  const b = b_.lock('CheckPerksButton');

  const dispatch = useDispatch();

  const { id } = record;

  const sendToFarmHandler = useCallback(() => {
    dispatch(sendUserToFarmRewards(id)).then(() => {
        message.success('Marked user to farm rewards');
        afterUpdate();
    }).catch(error => {
        console.log(error);
        message.error('Can\'t send user to farm rewards');
    })
}, [dispatch, afterUpdate, id]);
  
  return (
    <>
      <Tooltip placement="topLeft" title={title}>
        <Button
          type="primary"
          style={{background: 'rgb(172 62 255)', borderColor: 'rgb(172 62 255)'}}
          icon={icon}
          onClick={sendToFarmHandler}
        />
      </Tooltip>
    </>
  );
}

export default SendToFarmRewardsButton
